<template>
  <div class="columnlistBox">
    <div v-for="(item,index) in columnlist" :key="index" class="column_li">
      <lisTemplate :list="item" />
    </div>
  </div>
</template>
<script>
import lisTemplate from '@/components/centerlist_specTopic_detial/template/index.vue'
export default {
  components: { lisTemplate },
  props: ['columnlist'],
  data() {
    return {
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .columnlistBox{
        font-size: 0;
        text-align: left;
        .column_li{
            display: inline-block;
            margin-right: 38px;
            margin-top: 20px;
            width: 268px;
            height: 278px;
            transition: 0.3s;
          background-color: #fff;
            &:hover{
                transform: translate(0,-3px);
            }

        }
      .column_li:nth-child(3n){
        margin-right: 0;
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .columnlistBox{
      margin-top: 0;
      padding: 0 20px;
      .column_li:nth-child(3n){
        margin: 0 auto 20px;
      }
      .column_li{
        margin: 0 auto 20px;
        display: block;
        height: auto;
        width: 100%;
        font-size: 0;
      }
    }
  }
</style>

